var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 34,
    viewBox: "0 0 26 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0C9.55344 0.00406601 6.2492 1.37501 3.81211 3.8121C1.37502 6.24919 0.00407984 9.55342 1.38307e-05 13C-0.00411413 15.8165 0.915899 18.5566 2.61892 20.8C2.61892 20.8 2.97347 21.2668 3.03137 21.3342L13 33.0909L22.9734 21.3283C23.0254 21.2656 23.3811 20.8 23.3811 20.8L23.3823 20.7964C25.0844 18.5541 26.004 15.8152 26 13C25.9959 9.55342 24.625 6.24919 22.1879 3.8121C19.7508 1.37501 16.4466 0.00406601 13 0ZM13 17.7273C12.065 17.7273 11.1511 17.45 10.3737 16.9306C9.59628 16.4111 8.99037 15.6728 8.63257 14.809C8.27478 13.9452 8.18116 12.9947 8.36357 12.0777C8.54597 11.1607 8.9962 10.3184 9.65732 9.6573C10.3184 8.99618 11.1608 8.54595 12.0778 8.36355C12.9948 8.18115 13.9453 8.27476 14.809 8.63256C15.6728 8.99036 16.4111 9.59626 16.9306 10.3737C17.45 11.1511 17.7273 12.065 17.7273 13C17.7257 14.2533 17.2272 15.4547 16.341 16.3409C15.4548 17.2271 14.2533 17.7257 13 17.7273Z",
    fill: "#FBF8EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMap);
export default __webpack_public_path__ + "static/media/location-map.310d2592663f8fc898548593523ecb72.svg";
export { ForwardRef as ReactComponent };